import { useSelector } from 'react-redux';

import type { SpartacuxRetentionState } from '../../../retention.model';

export const msfHomepageErrorSelector = (
  state: SpartacuxRetentionState,
): string | undefined => state.retention?.homepage?.error;

export const useMsfHomepageError = () => useSelector(msfHomepageErrorSelector);
